import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { money } from "../lib/api";

export default function ProductCard({ product, stamp = false }) {
  return (
    <motion.article
      data-testid={`product-card-${product.id}`}
      whileHover={{ y: -6 }}
      transition={{ type: "spring", stiffness: 400, damping: 22 }}
      className="card-chunky relative flex h-full flex-col overflow-hidden text-charcoal"
    >
      <Link to={`/product/${product.id}`} data-testid={`product-card-link-${product.id}`} className="relative block border-b-2 border-charcoal" style={{ backgroundColor: product.tile_color }}>
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="aspect-[4/3] w-full object-cover transition-transform duration-300 hover:scale-[1.03]"
        />
        {product.rare && (
          <span className={`absolute left-3 top-3 rounded-full border-2 border-charcoal bg-yellow px-3 py-1 font-mono text-[10px] font-bold uppercase text-charcoal shadow-hard-sm ${stamp ? "-rotate-6" : ""}`}>
            Limited
          </span>
        )}
        {product.staff_pick && (
          <span className="absolute right-3 top-3 rounded-full border-2 border-charcoal bg-blue px-3 py-1 font-mono text-[10px] font-bold uppercase text-white shadow-hard-sm">
            Staff Pick
          </span>
        )}
      </Link>
      <div className="flex flex-1 flex-col gap-2 p-5">
        <span className="font-mono text-[10px] uppercase tracking-wide text-charcoal/60">
          {product.brand} / {product.era} / {product.category}
        </span>
        <Link to={`/product/${product.id}`} className="font-display text-lg font-extrabold uppercase leading-tight tracking-tight hover:text-blue">
          {product.name}
        </Link>
        <p className="text-sm text-charcoal/70">{product.tagline}</p>
        <div className="mt-auto flex items-center justify-between gap-3 pt-3">
          <span data-testid={`product-price-${product.id}`} className="font-display text-2xl font-extrabold">{money(product.price)}</span>
          <a
            href={product.affiliate_url}
            target="_blank"
            rel="sponsored noopener"
            data-testid={`product-buy-${product.id}`}
            className="btn-chunky bg-charcoal px-4 py-2 text-xs text-cream hover:bg-blue"
          >
            Buy on {product.retailer}
          </a>
        </div>
      </div>
    </motion.article>
  );
}
